export class GridStateColumn {
    public colId: string;

    public width?: number | undefined;

    public flex?: number;

    public constructor(colId: string, width?: number, flex?: number) {
        this.colId = colId;
        this.width = width;
        this.flex = flex;
    }
}
